module.exports = __webpack_public_path__ + "img/home-02.711e369e.png";